import Vue from "vue";
import Toast from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";

const options = {
  newestOnTop: true,
  position: "bottom-center",
  closeButton: false,
  hideProgressBar: true,
  // timeout: 3000,
  closeOnClick: false,
  toastClassName: "custom-toast",
  bodyClassName: "custom-toast-body"
};

Vue.use(Toast, options);
